<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane key="1">
        <span slot="tab">
          Distribución
        </span>
        <g-master name="distribucion"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  :actions="master.actions"
                  @action="masterAction"
                  ref="masterComponent"
                  modalWidth="80%"
                  @params="paramsTable"
        >
          <template slot="customButton">
            <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
          </template>
          <template slot="expandedRowRender" slot-scope="{text}">
            <template v-for="ve in master.valoresExpandidos">
              {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
            </template>
          </template>
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Empleados')"
                          :formItemConfig="fiOptions"
                          endpoint="empleado_act_ret_liq_def"
                          ref="empComponent"
                          :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                >
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('PERSONALIZACION_CENTRO_COSTO_ID_UNIDAD')">
                  <a-input
                    v-decorator="['unit_id', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Nombre Unidad')">
                  <a-input
                    v-decorator="['unit_name', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Agencia')">
                  <a-input
                    v-decorator="['segment_id', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Nombre Agencia')">
                  <a-input
                    v-decorator="['segment_name', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('PERSONALIZACION_CENTRO_COSTO_ID_CENTRO_DE_COSTOS')">
                  <a-input
                    v-decorator="['cc_id', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Nombre Centro de costo')">
                  <a-input
                    v-decorator="['cc_name', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('PERSONALIZACION_CENTRO_COSTO_PROYECTO')">
                  <a-input
                    v-decorator="['prj_id', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Nombre Proyecto')">
                  <a-input
                    v-decorator="['prj_name', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Tipo cc')">
                  <a-input
                    v-decorator="['type_cc', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Distribución')">
                  <a-input-number style="width: 100%"
                                  v-decorator="['distribution', { rules: [{ required: false}] }]"
                  ></a-input-number>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Concepto a distribuir')">
                  <a-input
                    v-decorator="['coc_distribution', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Año')" v-bind="fiOptions">
                  <a-select v-decorator="['year', { rules: [
                            { required: false},
                           ] }]" style="width: 100%">
                    <a-select-option v-for="year_ in years" :key="year_">
                      {{ year_ }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Mes')" v-bind="fiOptions">
                  <a-select v-decorator="['month', { rules: [
                            { required: false},
                           ] }]" style="width: 100%">
                    <a-select-option v-for="month_ in months_name" :key="month_.value">
                      {{ month_.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Documento')">
                  <a-input
                    v-decorator="['dist_document', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
            </a-row>
          </template>
        </g-master>
      </a-tab-pane>
      <a-tab-pane key="2" v-if="roleLoad">
        <span slot="tab">
          <g-wiki width="50%" keyValue="WIKI_CARGUE_DIST">
            <template slot="customText">
              <a-button type="primary" value="large" :loading="loadingTemplate" @click="downloadTemplate">
                <a-icon type="file-excel"/>
                Plantilla excel
              </a-button>
            </template>
          </g-wiki>
          Cargue Masivo
        </span>
        <cargue-dist @loadData="loadData"/>
      </a-tab-pane>
      <a-tab-pane tab="Distribución Historico" key="3">
        <distribution-cc-hist/>
      </a-tab-pane>
    </a-tabs>

    <a-modal v-model="actualizarDistribucionVisible" title="Actualizar Factores de Distribución"
             @ok="actualizarFactores">
      <a-spin :spinning="actualizarDistribucionLoading">
        <a-form-model :model="actualizarDistribucionModel" ref="actForm">
          <a-form-model-item label="Año" prop="year" :rules="[{ required: true, message: 'Valor requerido' }]">
            <a-input-number style="width: 100%" v-model="actualizarDistribucionModel.year"></a-input-number>
          </a-form-model-item>
          <a-form-model-item label="Mes" prop="month" :rules="[{ required: true, message: 'Valor requerido' }]">
            <a-input-number style="width: 100%" v-model="actualizarDistribucionModel.month"></a-input-number>
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-modal>

  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    mounted () {
      this.httpClient = new HttpUtil()
      this.yearsSelect()
    },
    data () {
      return {
        months_name: [
          {name: 'Enero', value: '1'},
          {name: 'Febrero', value: '2'},
          {name: 'Marzo', value: '3'},
          {name: 'Abril', value: '4'},
          {name: 'Mayo', value: '5'},
          {name: 'Junio', value: '6'},
          {name: 'Julio', value: '7'},
          {name: 'Agosto', value: '8'},
          {name: 'Septiembre', value: '9'},
          {name: 'Octubre', value: '10'},
          {name: 'Noviembre', value: '11'},
          {name: 'Diciembre', value: '12'}
        ],
        yearToday: parseInt(moment().format('YYYY')),
        years: [],
        loadingTemplate: false,
        fileNameExcel: 'distribucion',
        paramsT: {},
        endpointExcel: 'distribution_cc_/downloadExcel',
        pageTitle: 'Distribución',
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          valoresExpandidos: [
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado', column: 'modified_on'}
          ],
          endpoint: 'distribution_cc',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'id',
              pagination: {
                pageSize: 10,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '30', '40'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            columns: [
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Mes', dataIndex: 'month', sorter: true},
              {title: 'Empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre Completo', dataIndex: 'full_name', sorter: true},
              {title: this.$t('PERSONALIZACION_CENTRO_COSTO_ID_UNIDAD'), dataIndex: 'unit_id', sorter: true},
              {title: 'Nombre Unidad', dataIndex: 'unit_name', sorter: true},
              {title: 'Agencia', dataIndex: 'segment_id', sorter: true, align: 'right'},
              {title: 'Nombre Agencia', dataIndex: 'segment_name', sorter: true, align: 'right'},
              {title: this.$t('PERSONALIZACION_CENTRO_COSTO_ID_CENTRO_DE_COSTOS'), dataIndex: 'cc_id', sorter: true, align: 'right'},
              {title: 'Nombre Centro de costo', dataIndex: 'cc_name', sorter: true, align: 'right'},
              {title: this.$t('PERSONALIZACION_CENTRO_COSTO_PROYECTO'), dataIndex: 'prj_id', sorter: true, align: 'right'},
              {title: 'Tipo cc', dataIndex: 'type_cc', sorter: true},
              {title: 'Distribución', dataIndex: 'distribution', sorter: true},
              {title: 'Concepto a distribuir', dataIndex: 'coc_distribution', sorter: true},
              {title: 'Documento', dataIndex: 'dist_document', sorter: true}
            ],
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                }
              ]
            },
            allowSelect: true,
            selectedRows: [],
            selectedRowKeys: []
          },
          modalFieldsSetup: [
            {name: 'cc_id'},
            {name: 'cc_name'},
            {name: 'coc_distribution'},
            {name: 'dist_document'},
            {name: 'distribution'},
            {name: 'id_emp'},
            {name: 'modified_by'},
            {name: 'modified_on'},
            {name: 'month'},
            {name: 'prj_id'},
            {name: 'prj_name'},
            {name: 'segment_id'},
            {name: 'segment_name'},
            {name: 'type_cc'},
            {name: 'unit_id'},
            {name: 'unit_name'},
            {name: 'year'}
          ],
          actions: [
            {
              name: 'masterCreate',
              text: 'Crear',
              permisos: [],
              props: {icon: 'plus', type: 'button'},
              fnVisible: () => !this.$userIsInrol('Query')
            },
            {
              name: 'rowClone',
              text: 'Clonar',
              permisos: [],
              props: {icon: 'plus', type: 'button'},
              fnVisible: () => !this.$userIsInrol('Query')
            },
            {
              name: 'actualizaDistribucionm',
              text: 'Actualizar Distribución',
              permisos: [],
              props: {icon: 'redo', type: 'button'},
              fnVisible: () => !this.$userIsInrol('Query')
            }
          ]
        },
        actualizarDistribucionVisible: false,
        actualizarDistribucionLoading: false,
        actualizarDistribucionModel: {}
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            if (!this.$isEmpty(action.record.id_emp)) {
              this.$refs.empComponent && this.$refs.empComponent.handleSearch(action.record.id_emp)
            }
            break
          case 'rowClone':
            if (this.$isEmpty(this.cloneTorecord)) {
              Mensajes.error('Error', 'Selecciona una fila para colonar')
              return
            }
            this.$confirm({
              title: 'Clonar',
              content: '¿Está seguro que desea clonar el registro?',
              onOk: () => {
                return new Promise((resolve, reject) => {
                  this.httpClient.getInstance().post(this.master.endpoint, {
                    ...this.cloneTorecord
                  })
                    .then((response) => {
                      let key = this.master.tableSetup.tableConfig.rowKey
                      let clone = {...this.cloneTorecord}
                      clone[key] = response.data[key]
                      this.$refs.masterComponent.$refs.datatable.data.unshift(clone)
                      this.$refs.masterComponent.$refs.datatable.handleRadioSelection(response.data)
                      this.master.tableSetup.selectedRowKeys = [response.data[key]]
                      this.master.tableSetup.selectedRows = [response.data]
                      resolve()
                    })
                    .catch((error) => {
                      Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible clonar el registro'))
                      reject(error)
                    })
                })
              },
              onCancel () { }
            })
            break
          case 'actualizaDistribucionm':
            this.actualizarDistribucionVisible = true
            break
        }
      },
      paramsTable (params) {
        this.paramsT = params
      },
      loadData () {
        this.$refs.masterComponent && this.$refs.masterComponent.$refs.datatable.loadData()
      },
      downloadTemplate () {
        this.loadingTemplate = true
        this.httpClient.getInstance().get('template_dist/download', {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }
          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          this.loadingTemplate = false
        })
      },
      yearsSelect () {
        for (let i = this.yearToday - 1; i <= (this.yearToday + 5); i++) {
          this.years.push(i)
        }
      },
      actualizarFactores () {
        if (this.actualizarDistribucionLoading) return
        this.$refs.actForm.validate(valid => {
          if (valid) {
            this.actualizarDistribucionLoading = true

            this.httpClient.getInstance().post('distribution_cc_/actualizarDistribucion', this.actualizarDistribucionModel).then((response) => {
              Mensajes.success('Correcto', 'Información actualizada correctamente.')
            }).catch((error) => {
              Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible realizar la solicitud.'))
            }).then(() => {
              this.actualizarDistribucionLoading = false
            })
          }
        })
      }
    },
    computed: {
      cloneTorecord () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0] : null
      },
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns}
      },
      roleLoad () {
        return this.$userIsInrol('Load')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/DistributionCc.vue